import React, { Component } from "react";
import "../styles/About.css";
import marsh from "./Images/marsh.jpg";
import robart from "./Images/robart.jpg";
import livingstone from "./Images/livingstone.jpg";
import benja from "./Images/benja.jpg";
import AboutImage from "./Images/about-image.jpg";
import Tj from "./Images/tj.jpg";
import Zago from "./Images/zago.jpg"
import Martin from "./Images/martin.jpg";
import Nancy from "./Images/nancy.jpg";
import Image13 from "./Images/image13.jpg";

export class AboutUs extends Component {
  render() {
    return (
      <div className="About">
        {/* <h4 className="heading-about">About Wazito</h4> */}
        <div className="about-history">
          <div className="about-image">
            <img src={AboutImage} alt="Nothing to display"  />
          </div>
          <div className="history">
            <h5 className="history-header">Our History</h5>
            <p className="History-content">
              Wazito Fitness is a not-for-profit gym that was founded in
              2016 by Livingstone Eshitika, a fitness enthusiast. It was
              founded on the tenets and philosophies of improving the
              standards of our society. Located in Lucky Summer, Ruaraka,
              this gym not only engages in training people to help them
              achieve their fitness goals but we also target to ensure their
              wellness through therapy programs. Besides, we are also
              determined to bring a change in our neighborhood and the
              society at large by advocating for fitness and sporting
              activities that reform and rehabilitate our youths within the
              society.As you all know, the issue of youth unemployment has
              resulted in desperation among the youths, which leads to
              escalated drug abuse, criminal activities and other delinquent
              behavior that do not conform to our societal values. Our
              activities are guided by our gym motto, which is “A fit body,
              a fit mind, a better society” and our core concepts are
              fitness, wellness and therapy. Since its inception in 2016,
              Wazito Fitness has managed to reform and rehabilitate over 50
              youths by enlisting them in our gym programs, which have
              helped them found a purposeful life in sports, hospitality
              industry, entertainment world and other ventures. The gym has
              also helped create employment by enrolling 9 personnel who
              work as gym instructors. Some of the workout the gym provide
              include Bodybuilding workouts, Aerobics, Zumba dance, mix
              martial art, katabox among others. Under the stewardship of
              the Gym Managers, Briton Amanya, Benjamin Akatsa and Aggrey
              Odinga, Wazito Fitness has managed to grow its customer base
              from 30 (2016) to 115 (2021).
            </p>
          </div>
        </div>


        <h2 className="trainer-header">Our Team</h2>
        <div className="trainers">
          <div className="trainer-div">
            <img src={livingstone} alt="Nothing to display" />
            <div className="trainer-info">
              <h3 className="trainer-name">LIVINGSTONE</h3>
              <span className="trainer-span">C.E.O</span>
            </div>
          </div>
          <div className="trainer-div">
            <img src={marsh} alt="Nothing to display" />
            <div className="trainer-info">
              <h3 className="trainer-name">MARSHLEE</h3>
              <span className="trainer-span">STEPS AEROBICS TRAINER </span>
            </div>
          </div>
          <div className="trainer-div">
            <img src={benja} alt="Nothing to display" />
            <div className="trainer-info">
              <h3 className="trainer-name">BENJAMIN</h3>
              <span className="trainer-span">WEIGHTS TRAINER </span>
            </div>
          </div>

          <div className="trainer-div">
            <img src={robart} alt="Nothing to display" />
            <div className="trainer-info">
              <h3 className="trainer-name">ROBERT</h3>
              <span className="trainer-span">AEROBICS TRAINER </span>
            </div>
          </div>
          <div className="trainer-div">
            <img src={Tj} alt="Nothing to display" />
            <div className="trainer-info">
              <h3 className="trainer-name">TJ</h3>
              <span className="trainer-span">ZUMBA DANCE TRAINER </span>
            </div>
          </div>
          <div className="trainer-div">
            <img src={Zago} alt="Nothing to display" />
            <div className="trainer-info">
              <h3 className="trainer-name">ZAGO</h3>
              <span className="trainer-span">MARTIAL ARTS TRAINER</span>
            </div>
          </div>
          <div className="trainer-div">
            <img src={Martin} alt="Nothing to display" />
            <div className="trainer-info">
              <h3 className="trainer-name">MARTIN</h3>
              <span className="trainer-span">AEROBICS</span>
            </div>
          </div>
          <div className="trainer-div">
            <img src={Nancy} alt="Nothing to display" />
            <div className="trainer-info">
              <h3 className="trainer-name">NANCY</h3>
              <span className="trainer-span">AEROBICS</span>
            </div>
          </div>
          <div className="trainer-div">
            <img src={Image13} alt="Nothing to display" />
            <div className="trainer-info">
              <h3 className="trainer-name">JAYSON</h3>
              <span className="trainer-span">WEIGHT TRAINER</span>
            </div>
          </div> 
        </div>
      </div>
    );
  }
}

export default AboutUs;
